export enum DocumentReferenceType {
  PROPERTY = 'IMOVEL',
  OWNER = 'PROPRIETARIO',
  PROJETO = 'PROJETO',
  CADASTRO = 'CADASTRO'
}
